/**
 * An autosaved lookup select (status, stage). A change is sent immediately.
 * A Kimble value outside the lookup (Q-f11.1-5) is shown as a disabled
 * "(from Kimble)" option until someone chooses a stage.
 */

interface Option {
  code: string;
  name: string;
}

interface EditableSelectCellProps {
  value: string | null;
  options: readonly Option[];
  label: string;
  onCommit: (code: string) => void;
  /** Shown when `value` is null, e.g. the Kimble stage text. */
  fallback?: string | null;
}

const UNSET = '';

export function EditableSelectCell({ value, options, label, onCommit, fallback }: EditableSelectCellProps) {
  return (
    <td className="col-edit">
      <select
        className="cell-select"
        aria-label={label}
        value={value ?? UNSET}
        onChange={(event) => {
          if (event.target.value !== UNSET && event.target.value !== value) onCommit(event.target.value);
        }}
      >
        {value == null && (
          <option value={UNSET} disabled>
            {fallback ? `${fallback} (from Kimble)` : '—'}
          </option>
        )}
        {options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.name}
          </option>
        ))}
      </select>
    </td>
  );
}
